import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { paragraphsReducerActions } from "@/store/actions";

// Use this hook to store the initial data from SSR to redux.
export const useStoreSSRInitialDataChapterParas = (itemOrItems) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const store = ({
      chapterId,
      paras,
      highlight
    }) => {
      if (chapterId && paras?.length) {
        dispatch(paragraphsReducerActions.fetchChapterParasSuccess(chapterId, paras, highlight));
      }
    };
    if (Array.isArray(itemOrItems)) {
      itemOrItems.forEach(store);
    } else {
      store(itemOrItems);
    }
  }, []);
};